import {
	CLEAR_NOTIFICATION,
	DECREMENT_SYNC_QUEUE,
	INCREMENT_SYNC_QUEUE,
	PUSH_NOTIFICATION,
	UPDATE_DISPLAY_SETTINGS,
	UPDATE_GAMMA_CASE_IDX,
	UPDATE_GAMMA_FOLDER,
	UPDATE_GAMMA_STATE,
	UPDATE_IMAGE_LOAD_PROGRESS,
	UPDATE_LAST_IMAGE_RENDER_TIME,
	UPDATE_LAST_MAP_COUNT, UPDATE_MAGIC_TOOL_DATA_RETRIEVAL,
	UPDATE_TAWK_BOT,
} from '../redux_constants/gamma.state.const';

export const updateGammaState = (state) => ({
    type: UPDATE_GAMMA_STATE,
    state: state,
});

export const incrementSyncQueue = () => ({
	type: INCREMENT_SYNC_QUEUE,
});

export const decrementSyncQueue = () => ({
	type: DECREMENT_SYNC_QUEUE,
});

export const pushNotification = (notification) => ({
    type: PUSH_NOTIFICATION,
    notification: notification,
});

export const clearNotification = (id) => ({
    type: CLEAR_NOTIFICATION,
    id: id,
});

export const updateActiveMap = (mapId) => updateGammaState({
    activeMapId: mapId,
});

export const updateDisplayedMap = (mapId) => updateGammaState({
	displayedMapId: mapId,
});

export const updateSync = (sync) => updateGammaState({
    sync: sync
});

export const updateSyncId = (syncId) => updateGammaState({
    syncId: syncId
});

export const updateActiveAnnoDrawer = (activeAnnoDrawer) => updateGammaState({
	activeAnnoDrawer: activeAnnoDrawer,
});

export const updateSelectedDrawColor = selectedDrawColor => updateGammaState({selectedDrawColor});

export const updateSelectedDrawWidth = selectedAnnoWidth => updateGammaState({selectedAnnoWidth});

export const updateLabellingImage = labellingImage => updateGammaState({labellingImage});

export const toggleTileMap = tileMapEnable => updateGammaState({tileMapEnable});

export const toggleBloodMap = bloodMapEnable => updateGammaState({bloodMapEnable});

export const updateScannerData = scannerData => updateGammaState({scannerData});

export const updateSelectedTileColor = selectedTileColor => updateGammaState({selectedTileColor});

export const updateSelectedTileSize = selectedTileSize => updateGammaState({selectedTileSize});

export const updateRescanThreshValue1 = rescanThreshValue1 => updateGammaState({rescanThreshValue1});
export const updateRescanThreshValue2 = rescanThreshValue2 => updateGammaState({rescanThreshValue2});

export const updateDisplaySettings = (displaySettings) => ({
	type: UPDATE_DISPLAY_SETTINGS, displaySettings,
})

export const updateDefaultStainSettings = (defaultStainSettings) => updateGammaState({
	defaultStainSettings: defaultStainSettings,
})

export const updateDisplaySettingsList = (displaySettingsList) => updateGammaState({
	displaySettingsList: displaySettingsList,
})

export const updateSettings = displaySettings => updateGammaState({displaySettings})

export const openTopApp = (topApp) => updateGammaState({topApp});

export const openBottomApp = (bottomApp) => updateGammaState({bottomApp});

// TODO: [Priyanshu] deprecate it
export const updateLastMapCount = () => ({
	type: UPDATE_LAST_MAP_COUNT,
});

export const updateTawkBot = (instance) => ({
	type: UPDATE_TAWK_BOT,
	instance: instance,
})

export const updateImageLoadProgress = (instance) => ({
	type: UPDATE_IMAGE_LOAD_PROGRESS,
	instance,
})

export const updateLastImageRenderTime = (instance) => ({
	type: UPDATE_LAST_IMAGE_RENDER_TIME,
	instance,
})

export const updatePatientFolder = (folder) => ({
	type: UPDATE_GAMMA_FOLDER,
	folder,
})

export const updateCaseIdx = (caseIdx) => ({
	type: UPDATE_GAMMA_CASE_IDX,
	caseIdx,
})

export const updateMagicToolDataRetrievalStatus = (instance) => ({
	type: UPDATE_MAGIC_TOOL_DATA_RETRIEVAL,
	instance,
})

export const setOsdFallbackFeatures = osdFallbackFeatures => updateGammaState({osdFallbackFeatures});
